import { FacebookRegularIcon, InstagramIcon, RedditIcon, TwitterIcon, WhatsAppIcon } from '@change/ds-icons';

export type Platform = 'reddit' | 'facebook' | 'twitter' | 'instagram' | 'whatsapp';

export const PLATFORM_CONFIG: Readonly<
	Record<
		Platform,
		{
			Icon: typeof FacebookRegularIcon;
			bgColor: string;
			bgGradient?: string;
			iconColor: string;
			brandLabel: string;
		}
	>
> = {
	reddit: {
		Icon: RedditIcon,
		bgColor: '#FF4500',
		iconColor: 'text-white',
		brandLabel: 'Reddit',
	},
	facebook: {
		Icon: FacebookRegularIcon,
		bgColor: '#0866FF',
		iconColor: 'text-white',
		brandLabel: 'Facebook',
	},
	twitter: {
		Icon: TwitterIcon,
		bgColor: '#000000',
		iconColor: 'text-white',
		brandLabel: 'Twitter',
	},
	instagram: {
		Icon: InstagramIcon,
		bgColor: '#E4405F',
		bgGradient: 'bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#515BD4]',
		iconColor: 'text-white',
		brandLabel: 'Instagram',
	},
	whatsapp: {
		Icon: WhatsAppIcon,
		bgColor: '#25D366',
		iconColor: 'text-white',
		brandLabel: 'WhatsApp',
	},
};
